<template>
  <!-- 2.0 创建渲染盒子 -->
  <div class="dsafsa">
    <div ref="main" :key="echarkey" style="width: 1600px; height: 400px"></div>
  </div>
</template>

<script>
// 1.0引入 Echarts
import * as echarts from "echarts";

export default {
  props: {
    options: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      echarkey: 1,
      myChartDom: "",
      isfirst: "0",
    };
  },
  methods: {
    init(item) {
      const dom = this.$refs.main;
      // //  3.创建渲染实例 ===> 初始第一次创建实例
      if (this.isfirst == 0) {
        this.myChartDom = echarts.init(dom);
        this.isfirst = 1;
      }
      this.myChartDom.setOption(item, true);
    },
  },
};
</script>
<style lang="scss" scoped>
.dsafsa {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
}
.attention {
  line-height: 360px;
}
.charts {
  opacity: 0;
}
</style>
